import { Colaborator } from "@/entities/colaborator";
import { useBusiness } from "@/hook/useBusiness";
import { useBusinessColaborator } from "@/hook/useBusinessColaborator";
import { useColaborator } from "@/hook/useColaborator";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
const UserBusiness = () => {
    const { ColaboratorsUse, getAllAdmin } = useColaborator();
    const leadId = Number(useParams().leadId);
    const [admins, setAdmins] = useState<Colaborator[]>([]);
    const [selectedAdmin, setSelectedAdmin] = useState<number | null>(null);
    const [selectedColabId, setSelectedColabId] = useState<number | null>(null);
    const [tableColabs, setTableColabs] = useState<Colaborator[]>([]);
    const {createBusinessColaborator,fetchBusinessColaborator,deleteBusinessColaborator } = useBusinessColaborator(leadId);
    const {updateBusiness} = useBusiness();

    const colaboratorAdd = ColaboratorsUse.map((colaborator) => ({
        id: colaborator.id,
        name: colaborator.name
    }));



    useEffect(() => {
    const fetchData = async () => {
        try {
            const businessData = await fetchBusinessColaborator();
            const colaboradoresFormatados = businessData.collaborators.map((item: any) => ({
                id: item.Collaborator.id,
                name: item.Collaborator.name,
                email: item.Collaborator.email,
                cellPhone: item.Collaborator.cellPhone,
                companyId: item.Collaborator.companyId,
            }));
            setTableColabs(colaboradoresFormatados)

            const adminsData = await getAllAdmin();
            if (adminsData) {
                setAdmins(adminsData);
            }
        } catch (error) {
            console.error('Erro ao buscar dados:', error);
        }
    };

    fetchData();
}, []);

    return (
        <div className='flex bg-indigo-200  justify-center w-[100%] h-screen'>
            <form className='flex my-4 px-2 w-[90%] h-[60%] h-auto bg-white rounded-xl flex-col gap-4' >
                <div className='grid grid-cols-1 py-4 px-4 h-[100%]  items-start justify-between flex-row gap-4'>
                    <div className='h-[90%] py-6'>
                        <div className='grid grid-cols-2 pb-12 gap-4 w-[100%]'>
                            <div className="w-[85%] mx-auto">
                                <label htmlFor="countries_disabled" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Selecione um Supervisor do negócio</label>
                                <select
                                    id="colaborators_select"
                                    onChange={(e) => setSelectedAdmin(Number(e.target.value))}
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                >   
                                    <option value="">Selecione um Supervisor do negócio</option>
                                    {admins.map((colab) => (
                                        <option key={colab.id} value={colab.id}>
                                            {colab.name}
                                        </option>
                                    ))}
                                </select>


                            </div>
                            <div className="w-[85%] mx-auto">
                                <label htmlFor="countries_disabled" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Adicione um colaborador</label>
                                <select
                                    id="colaborator_select"
                                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                                    onChange={(e) => setSelectedColabId(Number(e.target.value))}
                                    value={selectedColabId || ""}
                                >
                                    <option value="">Adicione um colaborador</option>
                                    {colaboratorAdd
                                        .filter((colab) => !tableColabs.find(c => c.id === colab.id)) // filtra os que já estão na tabela
                                        .map((colab) => (
                                            <option key={colab.id} value={colab.id}>
                                                {colab.name}
                                            </option>
                                        ))}
                                </select>


                            </div>
                            <button
                                type="button"
                                className= "text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                                onClick={() => {
                                    if (selectedAdmin) {
                                        const selected = ColaboratorsUse.find(c => c.id === selectedAdmin);
                                        if (selected) {
                                            createBusinessColaborator({
                                                collaboratorId: selectedAdmin,
                                                isAdmin: true,
                                                businessId: leadId,
                                            });
                                            updateBusiness(Number(leadId),{administratorId: selectedAdmin});
                                            setTableColabs(prev => [...prev, selected]);
                                            setSelectedAdmin(null); // Limpa o select
                                        }
                                    }
                                }}
                            >
                                Selecionar Supervisor do negócio
                            </button>
                            <button
                                type="button"
                                className="col-start-2 text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center me-2 mb-2"
                                onClick={() => {
                                    if (selectedColabId) {
                                        // Encontrar o colaborador completo pela ID
                                        const selected = ColaboratorsUse.find(c => c.id === selectedColabId);
                                        if (selected) {
                                            // Adicionar o colaborador completo à tabela
                                            createBusinessColaborator({
                                                collaboratorId: selectedColabId,
                                                isAdmin: false,
                                                businessId: leadId,
                                            });
                                            setTableColabs(prev => [...prev, selected]);
                                            setSelectedColabId(null);
                                        }
                                    }
                                }}
                            >
                                Adicionar
                            </button>

                        </div>


                        <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
                            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                                <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                                    <tr>
                                        <th scope="col" className="px-6 py-3">
                                            Colaborador
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Email
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Telefone
                                        </th>
                                        <th scope="col" className="px-6 py-3">
                                            Ação
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableColabs.map((colab) => (
                                        <tr key={colab.id}>
                                            <td className="px-6 py-4">{colab.name}</td>
                                            <td className="px-6 py-4">{colab.email}</td>
                                            <td className="px-6 py-4">{colab.cellPhone}</td>
                                            <td className="px-6 py-4">
                                                <button
                                                    className="text-red-500"
                                                    onClick={() => {
                                                        setTableColabs(prev => prev.filter(c => c.id !== colab.id));
                                                        deleteBusinessColaborator(colab.id,leadId);
                                                    }}
                                                >
                                                    Remover
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>

                            </table>
                        </div>

                    </div>
                </div>
            </form>
        </div>
    );
};

export default UserBusiness;
